import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetContractorCompanies = () => {
  const data = useQuery(
    ["contractorCompaniesList"],
    () =>
      axiosClient.get(`/CompanyContractor/GetCompanyContractorList`)
  );

  return data;
};
export default useGetContractorCompanies;
